"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sidePane;
exports.getDefaultState = getDefaultState;
var _sidePaneActions = require("../actions/sidePaneActions");
var initialState = getDefaultState();
function sidePane() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    payload = _ref.payload,
    type = _ref.type;
  switch (type) {
    case _sidePaneActions.CLOSE_SIDE_PANE:
      return getDefaultState();
    case _sidePaneActions.OPEN_SIDE_PANE:
      return {
        isOpen: true,
        name: payload.pane,
        data: payload.sidePaneProps
      };
    default:
      return state;
  }
}
function getDefaultState() {
  return {
    isOpen: false,
    name: '',
    data: {}
  };
}